import React, { useContext, useState } from "react";
import styles from "./Navbar.module.css";
import { Link, useNavigate } from "react-router-dom";
import { lapContext } from "../../context/OverLapContext";
import { FaAngleUp } from "react-icons/fa";
import { FaAngleDown } from "react-icons/fa";
import { MdPerson } from "react-icons/md";
import { IoSettingsSharp } from "react-icons/io5";
import { SiGooglemarketingplatform } from "react-icons/si";
import { IoLogOut } from "react-icons/io5";
import { FaUserCircle } from "react-icons/fa";
import { FaHome } from "react-icons/fa";

function Navbar() {
  const { setUser } = useContext(lapContext);
  const [collapse, setCollapse] = useState(false);
  const [collapseOne, setCollapseOne] = useState(false);
  const [collapseTwo, setCollapseTwo] = useState(false);
  const [collapseEmail, setCollapseEmail] = useState(false);
  const [collapseUser, setCollapseUser] = useState(false);
  const userType = sessionStorage.getItem("user");
  const navigate = useNavigate();

  function collapseHandler(setcoll) {
    setcoll((prev) => {
      return !prev;
    });
  }

  async function LogoutHandler() {
    try {
      const result = await fetch(
        "https://artmadein-dashboard-backend.onrender.com/api/v1/user/logout",
        // `http://localhost:5000/api/v1/user/logout`,
        {
          method: "POST",
          credentials: "include",
        }
      );
      if (result.ok) {
        setUser("");
        sessionStorage.clear();
        navigate("/login");
      }
    } catch (err) {
      console.log("Logout Err", err);
    }
  }
  return (
    <div className={styles.navbarContainer}>
      <div className={styles.navbarBox}>
        <header className={styles.header}>
          {userType === "admin" ? (
            <>
              <div className={styles.navBarBtnBox}>
                <FaHome
                  style={{
                    fontSize: "20px",
                    color: "white",
                  }}
                ></FaHome>
                <Link className={styles.link} to="/">
                  <p
                    style={{
                      fontSize: "20px",
                      paddingTop: "0px",
                    }}
                  >
                    Home
                  </p>
                </Link>
              </div>
              <div style={{ marginBottom: "15px" }}>
                <div className={styles.btnBoxButtonTwo}>
                  <div>
                    <SiGooglemarketingplatform
                      style={{
                        fontSize: "20px",
                        color: "white",
                      }}
                    ></SiGooglemarketingplatform>{" "}
                  </div>
                  <p
                    style={{
                      fontSize: "20px",
                      paddingTop: "0px",
                    }}
                    className={styles.collpaseBtn}
                    onClick={() => collapseHandler(setCollapseEmail)}
                  >
                    Marketing{" "}
                    {collapseEmail ? (
                      <FaAngleUp></FaAngleUp>
                    ) : (
                      <FaAngleDown></FaAngleDown>
                    )}
                  </p>
                </div>
                <div
                  className={
                    collapseEmail
                      ? `${styles.collapseEnd}`
                      : `${styles.collapse}`
                  }
                >
                  <Link className={styles.link} to="/marketing/emailmarketing">
                    Email Marketing
                  </Link>
                  <Link
                    className={styles.link}
                    to="/marketing/multipleemailmarketing"
                  >
                    Multiple Email Marketing
                  </Link>
                  <Link className={styles.link} to="/marketing/emailtxt">
                    Email Text
                  </Link>
                </div>
              </div>

              <div style={{ marginBottom: "15px" }}>
                <p
                  className={styles.collpaseBtn}
                  onClick={() => collapseHandler(setCollapseOne)}
                >
                  <MdPerson></MdPerson> Client{" "}
                  {collapseOne ? (
                    <FaAngleUp></FaAngleUp>
                  ) : (
                    <FaAngleDown></FaAngleDown>
                  )}
                </p>
                <div
                  className={
                    collapseOne ? `${styles.collapseEnd}` : `${styles.collapse}`
                  }
                >
                  <Link className={styles.link} to="/client/createclient">
                    Create
                  </Link>
                  <Link className={styles.link} to={"/client/potentialclient"}>
                    View
                  </Link>
                </div>
              </div>
              <div style={{ marginBottom: "15px" }}>
                <p
                  className={styles.collpaseBtn}
                  onClick={() => collapseHandler(setCollapseUser)}
                >
                  <FaUserCircle></FaUserCircle> User{" "}
                  {collapseUser ? (
                    <FaAngleUp></FaAngleUp>
                  ) : (
                    <FaAngleDown></FaAngleDown>
                  )}
                </p>
                <div
                  className={
                    collapseUser
                      ? `${styles.collapseEnd}`
                      : `${styles.collapse}`
                  }
                >
                  <Link className={styles.link} to="/user/createuser">
                    Create User
                  </Link>
                </div>
              </div>

                  {/* code Asif */}
              <div style={{ marginBottom: "15px" }}>
                <div className={styles.btnBoxButtonTwo}>
                  <div>
                    <SiGooglemarketingplatform
                      style={{
                        fontSize: "20px",
                        color: "white",
                      }}
                    ></SiGooglemarketingplatform>{" "}
                  </div>
                  <p
                    style={{
                      fontSize: "20px",
                      paddingTop: "0px",
                    }}
                    className={styles.collpaseBtn}
                    onClick={() => collapseHandler(setCollapseTwo)}
                  >
                    Codeasif{" "}
                    {collapseTwo ? (
                      <FaAngleUp></FaAngleUp>
                    ) : (
                      <FaAngleDown></FaAngleDown>
                    )}
                  </p>
                </div>
                <div
                  className={
                    collapseTwo
                      ? `${styles.collapseEnd}`
                      : `${styles.collapse}`
                  }
                >
                  <Link className={styles.link} to="/marketing/emailmarketing">
                    Email Marketing
                  </Link>
                  <Link
                    className={styles.link}
                    to="/marketing/codeasifemail"
                  >
                    Multiple Email Marketing
                  </Link>
                  <Link className={styles.link} to="/marketing/emailtxt">
                    Email Text
                  </Link>
                </div>
              </div>
              <div style={{ marginBottom: "15px" }}>
                <p
                  className={styles.collpaseBtn}
                  onClick={() => collapseHandler(setCollapse)}
                >
                  <IoSettingsSharp></IoSettingsSharp> Settings{" "}
                  {collapse ? (
                    <FaAngleUp></FaAngleUp>
                  ) : (
                    <FaAngleDown></FaAngleDown>
                  )}
                </p>
                <div
                  className={
                    collapse ? `${styles.collapseEnd}` : `${styles.collapse}`
                  }
                >
                  <Link className={styles.link} to="/setting/updatepassword">
                    Update Password
                  </Link>
                  <Link className={styles.link} to={"/setting/chnageemail"}>
                    Change Email Id
                  </Link>
                </div>
              </div>
              <div style={{ marginBottom: "15px" }}>
                <Link className={styles.link} to="" onClick={LogoutHandler}>
                  <IoLogOut></IoLogOut> Logout
                </Link>
              </div>
            </>
          ) : (
            <div>
              <Link className={styles.link} to={"/login"}>
                Login
              </Link>
            </div>
          )}
        </header>
      </div>
    </div>
  );
}

export default Navbar;
